import { render, staticRenderFns } from "./addCategoryee.vue?vue&type=template&id=9dd4cc38&scoped=true&"
import script from "./addCategoryee.vue?vue&type=script&lang=js&"
export * from "./addCategoryee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd4cc38",
  null
  
)

export default component.exports